import React, { Fragment, ReactNode, useEffect, useMemo, useState } from 'react';
import PadV2PxElementCard from './PadV2PxElementCard';
import { IMilestoneHistory } from '../../../../common/types/milestones';
import {
    IMilestoneCategory,
    IMilestoneData,
    MilestoneData,
    UIMilestone,
} from '../../../../../api/getMilestone';
import {
    mileStoneCategoryName,
    milestoneCategories,
} from '../../../../common/constants/milestones';
import { Divider, Dropdown, Menu, Radio, Skeleton, notification } from 'antd';
import { editIcon, rightArrowIcon2, tickIcon2 } from '../../../../common/Icons';
import { track } from '../../../../../tracking';
import onContainerClick from '../../../../../pages/prescriptionPad/onClickContainer';
import { getMilestoneSummary } from '../../../../../modules/milestone';
import MilestoneStatusSummary from '../../../../MilestoneStatusSummary';
import isEmpty from 'lodash/isEmpty';

const icons = (
    className: string,
): Record<
    IMilestoneCategory,
    { iconFilled: ReactNode; iconOutline: ReactNode; textClassName: string }
> => {
    return {
        'ek-7084767782': {
            iconFilled: (
                <svg
                    viewBox="0 0 11 14"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`w-11 h-14 ${className}`}
                >
                    <path d="M3.67188 2.85938C3.67188 2.22461 4.00195 1.61523 4.58594 1.28516C5.14453 0.955078 5.83008 0.955078 6.41406 1.28516C6.97266 1.61523 7.32812 2.22461 7.32812 2.85938C7.32812 3.51953 6.97266 4.12891 6.41406 4.45898C5.83008 4.78906 5.14453 4.78906 4.58594 4.45898C4.00195 4.12891 3.67188 3.51953 3.67188 2.85938ZM0.802734 4.30664C1.13281 3.84961 1.76758 3.74805 2.22461 4.07812L3.13867 4.73828C3.82422 5.24609 4.63672 5.5 5.5 5.5C6.33789 5.5 7.15039 5.24609 7.83594 4.73828L8.75 4.07812C9.20703 3.74805 9.8418 3.84961 10.1719 4.30664C10.502 4.76367 10.4004 5.39844 9.94336 5.72852L9.0293 6.38867C8.67383 6.64258 8.31836 6.8457 7.9375 7.02344V7.9375H3.0625V7.02344C2.65625 6.8457 2.30078 6.64258 1.94531 6.38867L1.03125 5.72852C0.574219 5.39844 0.472656 4.76367 0.802734 4.30664ZM3.08789 9.00391L4.63672 10.3496L3.97656 11.2891L4.58594 11.8984C4.99219 12.3047 4.99219 12.9395 4.58594 13.3457C4.17969 13.752 3.54492 13.7266 3.13867 13.3457L1.91992 12.127C1.58984 11.7715 1.53906 11.2129 1.81836 10.832L3.08789 9.00391ZM6.36328 10.3496L7.88672 9.00391L9.15625 10.832C9.43555 11.2129 9.41016 11.7715 9.05469 12.127L7.83594 13.3457C7.42969 13.7266 6.79492 13.7266 6.38867 13.3457C6.00781 12.9395 6.00781 12.3047 6.38867 11.8984L7.02344 11.2891L6.36328 10.3496Z" />
                </svg>
            ),
            iconOutline: (
                <svg
                    viewBox="0 0 448 512"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`w-11 h-14 ${className}`}
                >
                    <path d="M224 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM224 0a80 80 0 1 1 0 160A80 80 0 1 1 224 0zM107.3 180.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l18.7 18.7c12.8 12.8 27.5 23.4 43.4 31.5c8.1 4.1 13.1 12.4 13.1 21.4v13 0H288l0-13c0-9 5.1-17.3 13.1-21.4c15.9-8.1 30.6-18.6 43.4-31.5l18.7-18.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-18.7 18.7c-26 26-61.2 40.6-97.9 40.6s-72-14.6-97.9-40.6l-18.7-18.7zM304.6 341.5l-24.1 21.1L304 392.9c6.8 8.8 6.7 21.1-.2 29.7L291.5 438c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l32-40c4.6-5.8 4.7-14 .1-19.8l-44.1-56.7zm-137 21.1l-24.1-21.1L99.4 398.2c-4.5 5.8-4.5 14 .1 19.8l32 40c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-12.3-15.4c-6.9-8.7-7-21-.2-29.7l23.6-30.3zM50.7 146.7c25-25 65.5-25 90.5 0L160 165.5c17 17 40 26.5 64 26.5s47-9.5 64-26.5l18.7-18.7c25-25 65.5-25 90.5 0s25 65.5 0 90.5L378.5 256c-12.9 12.9-27.2 23.9-42.5 33.1l0 14.6 50.5 65c18.2 23.4 18 56.2-.5 79.3l-32 40c-22.1 27.6-62.4 32.1-90 10s-32.1-62.4-10-90l.5-.6-5.8-7.4H199.3l-5.8 7.4 .5 .6c22.1 27.6 17.6 67.9-10 90s-67.9 17.6-90-10L62 448c-18.5-23.1-18.7-55.9-.5-79.3l50.5-65 0-14.6c-15.4-9.2-29.7-20.3-42.5-33.1L50.7 237.3c-25-25-25-65.5 0-90.5z" />
                </svg>
            ),
            textClassName: 'pl-24',
        },
        'ek-1025408070': {
            iconFilled: (
                <svg
                    viewBox="0 0 13 14"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`w-13 h-14 ${className}`}
                >
                    <path d="M7.8125 1.4375V6.71875C7.8125 6.94727 7.99023 7.125 8.21875 7.125C8.42188 7.125 8.625 6.94727 8.625 6.71875V2.25C8.625 1.81836 8.98047 1.4375 9.4375 1.4375C9.86914 1.4375 10.25 1.81836 10.25 2.25V6.71875C10.25 6.94727 10.4277 7.125 10.6562 7.125C10.8594 7.125 11.0625 6.94727 11.0625 6.71875V3.875C11.0625 3.44336 11.418 3.0625 11.875 3.0625C12.3066 3.0625 12.6875 3.44336 12.6875 3.875V9.15625C12.6875 11.6445 10.6816 13.625 8.21875 13.625H7.71094C6.21289 13.625 4.74023 13.0664 3.64844 12L0.804688 9.2832C0.398438 8.90234 0.373047 8.26758 0.779297 7.86133C1.16016 7.45508 1.79492 7.42969 2.20117 7.81055L3.75 9.2832C3.75 9.25781 3.75 9.20703 3.75 9.15625V2.25C3.75 1.81836 4.10547 1.4375 4.5625 1.4375C4.99414 1.4375 5.375 1.81836 5.375 2.25V6.71875C5.375 6.94727 5.55273 7.125 5.78125 7.125C5.98438 7.125 6.1875 6.94727 6.1875 6.71875V1.4375C6.1875 1.00586 6.54297 0.625 7 0.625C7.43164 0.625 7.8125 1.00586 7.8125 1.4375Z" />
                </svg>
            ),
            iconOutline: (
                <svg
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`w-13 h-14 ${className}`}
                >
                    <path d="M256 0c-25.3 0-47.2 14.7-57.6 36c-7-2.6-14.5-4-22.4-4c-35.3 0-64 28.7-64 64V261.5l-2.7-2.7c-25-25-65.5-25-90.5 0s-25 65.5 0 90.5L106.5 437c48 48 113.1 75 181 75H296h8c1.5 0 3-.1 4.5-.4c91.7-6.2 165-79.4 171.1-171.1c.3-1.5 .4-3 .4-4.5V160c0-35.3-28.7-64-64-64c-5.5 0-10.9 .7-16 2V96c0-35.3-28.7-64-64-64c-7.9 0-15.4 1.4-22.4 4C303.2 14.7 281.3 0 256 0zM240 96.1c0 0 0-.1 0-.1V64c0-8.8 7.2-16 16-16s16 7.2 16 16V95.9c0 0 0 .1 0 .1V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96c0 0 0 0 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16v55.9c0 0 0 .1 0 .1v80c0 13.3 10.7 24 24 24s24-10.7 24-24V160.1c0 0 0-.1 0-.1c0-8.8 7.2-16 16-16s16 7.2 16 16V332.9c-.1 .6-.1 1.3-.2 1.9c-3.4 69.7-59.3 125.6-129 129c-.6 0-1.3 .1-1.9 .2H296h-8.5c-55.2 0-108.1-21.9-147.1-60.9L52.7 315.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L119 336.4c6.9 6.9 17.2 8.9 26.2 5.2s14.8-12.5 14.8-22.2V96c0-8.8 7.2-16 16-16c8.8 0 16 7.1 16 15.9V232c0 13.3 10.7 24 24 24s24-10.7 24-24V96.1z" />
                </svg>
            ),
            textClassName: 'pl-26',
        },
        'ek-9994397806': {
            iconFilled: (
                <svg
                    viewBox="0 0 15 14"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`w-15 h-14 ${className}`}
                >
                    <path d="M7.5 13.625C5.16406 13.625 3.03125 12.4062 1.86328 10.375C0.695312 8.36914 0.695312 5.90625 1.86328 3.875C3.03125 1.86914 5.16406 0.625 7.5 0.625C9.81055 0.625 11.9434 1.86914 13.1113 3.875C14.2793 5.90625 14.2793 8.36914 13.1113 10.375C11.9434 12.4062 9.81055 13.625 7.5 13.625ZM5.16406 8.90234C5.01172 8.72461 4.75781 8.72461 4.58008 8.85156C4.40234 9.00391 4.40234 9.25781 4.5293 9.43555C5.11328 10.0957 6.07812 10.7812 7.5 10.7812C8.89648 10.7812 9.86133 10.0957 10.4453 9.43555C10.5723 9.25781 10.5723 9.00391 10.3945 8.85156C10.2168 8.72461 9.96289 8.72461 9.81055 8.90234C9.37891 9.43555 8.5918 9.96875 7.5 9.96875C6.38281 9.96875 5.62109 9.43555 5.16406 8.90234ZM4.65625 5.90625C4.65625 6.36328 5.01172 6.71875 5.46875 6.71875C5.92578 6.71875 6.28125 6.36328 6.28125 5.90625C6.28125 5.47461 5.92578 5.09375 5.46875 5.09375C5.01172 5.09375 4.65625 5.47461 4.65625 5.90625ZM9.53125 5.09375C9.07422 5.09375 8.71875 5.47461 8.71875 5.90625C8.71875 6.36328 9.07422 6.71875 9.53125 6.71875C9.98828 6.71875 10.3438 6.36328 10.3438 5.90625C10.3438 5.47461 9.98828 5.09375 9.53125 5.09375Z" />
                </svg>
            ),
            iconOutline: (
                <svg
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`w-15 h-14 ${className}`}
                >
                    <path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm177.6 62.1C192.8 334.5 218.8 352 256 352s63.2-17.5 78.4-33.9c9-9.7 24.2-10.4 33.9-1.4s10.4 24.2 1.4 33.9c-22 23.8-60 49.4-113.6 49.4s-91.7-25.5-113.6-49.4c-9-9.7-8.4-24.9 1.4-33.9s24.9-8.4 33.9 1.4zM144.4 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                </svg>
            ),
            textClassName: 'pl-28',
        },
        'ek-9916604356': {
            iconFilled: (
                <svg
                    viewBox="0 0 18 10"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`w-18 h-10 ${className}`}
                >
                    <path d="M0.875 1.875C0.875 0.986328 1.58594 0.25 2.5 0.25H7.375H8.59375H9H15.5C16.3887 0.25 17.125 0.986328 17.125 1.875V8.375C17.125 9.28906 16.3887 10 15.5 10H9H8.59375H7.375H2.5C1.58594 10 0.875 9.28906 0.875 8.375V1.875ZM9 1.875V8.375H15.5V1.875H9ZM5.39453 3.09375C5.31836 2.91602 5.11523 2.78906 4.9375 2.78906C4.73438 2.78906 4.53125 2.91602 4.45508 3.09375L2.83008 6.75C2.72852 7.00391 2.83008 7.30859 3.08398 7.43555C3.36328 7.53711 3.64258 7.43555 3.76953 7.18164L3.99805 6.64844H5.85156L6.08008 7.18164C6.20703 7.43555 6.51172 7.53711 6.76562 7.43555C7.01953 7.30859 7.12109 7.00391 7.01953 6.75L5.39453 3.09375ZM4.9375 4.56641L5.41992 5.63281H4.45508L4.9375 4.56641ZM12.25 2.78906C12.5293 2.78906 12.7578 3.01758 12.7578 3.29688V3.39844H13.875H14.2812C14.5605 3.39844 14.7891 3.62695 14.7891 3.90625C14.7891 4.18555 14.5605 4.41406 14.2812 4.41406H14.2305L14.1797 4.54102C13.9512 5.15039 13.6211 5.73438 13.1641 6.19141C13.1895 6.2168 13.2148 6.2168 13.2402 6.24219L13.7227 6.52148C13.9512 6.67383 14.0273 6.97852 13.9004 7.23242C13.748 7.46094 13.4434 7.53711 13.1895 7.41016L12.7324 7.10547C12.6055 7.05469 12.5039 6.97852 12.377 6.90234C12.123 7.08008 11.8438 7.25781 11.5137 7.38477L11.4375 7.43555C11.1836 7.53711 10.8789 7.43555 10.752 7.18164C10.6504 6.90234 10.7773 6.62305 11.0312 6.49609L11.1074 6.4707C11.2852 6.39453 11.4375 6.29297 11.5898 6.2168L11.2852 5.91211C11.082 5.70898 11.082 5.37891 11.2852 5.17578C11.4629 4.97266 11.793 4.97266 11.9961 5.17578L12.3516 5.55664H12.377C12.6816 5.22656 12.9355 4.8457 13.1387 4.41406H12.25H10.4219C10.1426 4.41406 9.91406 4.18555 9.91406 3.90625C9.91406 3.62695 10.1426 3.39844 10.4219 3.39844H11.7422V3.29688C11.7422 3.01758 11.9707 2.78906 12.25 2.78906Z" />
                </svg>
            ),
            iconOutline: (
                <svg
                    viewBox="0 0 640 512"
                    xmlns="http://www.w3.org/2000/svg"
                    className={`w-18 h-14 ${className}`}
                >
                    <path d="M304 96V416H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H304zm32 0H576c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H336V96zm304 32c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V128zM174.9 170.1C172.4 164 166.5 160 160 160s-12.4 4-14.9 10.1l-64 160c-3.3 8.2 .7 17.5 8.9 20.8s17.5-.7 20.8-8.9l8.8-21.9h80.7l8.8 21.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-64-160zm-14.9 49L187.6 288H132.4L160 219.1zM496 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 41.2l-.2 .6c-8.2 22.6-21.4 42.9-38.2 59.4l-.8-.8-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.9 20.9c-5 3.2-10.1 6.2-15.5 8.8l-17.3 8.6c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l17.3-8.6c9.1-4.6 17.8-9.8 26-15.7c5.9 4.4 12.1 8.6 18.4 12.4l18.9 11.3c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-18.9-11.3c-3.4-2-6.7-4.1-9.9-6.4c19.1-19.4 34.1-42.9 43.6-69l4.2-11.6H560c8.8 0 16-7.2 16-16s-7.2-16-16-16H544 496V176z" />
                </svg>
            ),
            textClassName: 'pl-30',
        },
    };
};

const DropdownComponent: React.FC<{
    currcatmilestones: IMilestoneData[];
    selectedMilestones: string[];
    onSave: (m: IMilestoneData) => void;
    onUpdateAll: () => void;
    markAllAchieved: (milestones: IMilestoneData[]) => void;
    category: IMilestoneCategory;
    setIsDropdownOpen: (val: boolean) => void;
}> = ({
    currcatmilestones,
    markAllAchieved,
    onSave,
    onUpdateAll,
    selectedMilestones,
    category,
    setIsDropdownOpen,
}) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <Dropdown
            overlay={
                <Menu className="flex max-h-200 overflow-y-auto hide-scrollbar rounded-4 flex-col p-0">
                    {currcatmilestones.map((m, idx) => (
                        <Fragment>
                            <Menu.Item
                                key={m.id}
                                onClick={
                                    selectedMilestones.includes(m.id)
                                        ? () =>
                                              notification.success({
                                                  message: 'Milestone already marked achieved',
                                                  duration: 2,
                                              })
                                        : (e) => {
                                              e.domEvent.stopPropagation();
                                              onSave(m);
                                          }
                                }
                                className={`px-10 py-8`}
                            >
                                <div className="flex w-full cursor-pointer items-start gap-4 hover-parent-element-v2">
                                    {selectedMilestones.includes(m.id) ? (
                                        <span className="relative top-3 mr-8 flex items-center justify-center rounded-full">
                                            {tickIcon2(
                                                'fill-darwin-green-primary font-700 w-14 h-14',
                                            )}
                                        </span>
                                    ) : (
                                        <span className="relative border w-14 h-14 border-darwin-neutral-900 bg-white top-3 mr-8 flex items-center justify-center rounded-full"></span>
                                    )}

                                    <p
                                        className="text-13 max-w-140"
                                        style={{ whiteSpace: 'break-spaces' }}
                                    >
                                        {m.name}
                                    </p>
                                    {selectedMilestones.includes(m.id) && (
                                        <span
                                            className="cursor-pointer relative top-4 hover-child-element-v2 ml-auto"
                                            onClick={onUpdateAll}
                                        >
                                            {editIcon('w-12 h-12')}
                                        </span>
                                    )}
                                </div>
                            </Menu.Item>
                            {idx !== currcatmilestones.length - 1 && <Divider className="m-0" />}
                        </Fragment>
                    ))}
                    <Menu.Item
                        onClick={() => markAllAchieved(currcatmilestones)}
                        className="flex sticky border-t border-darwin-neutral-100 bg-white bottom-0 cursor-pointer py-8 justify-center text-darwin-accent-bright-blue-800"
                    >
                        <p className="text-13 text-center font-700">Mark all as achieved</p>
                    </Menu.Item>
                </Menu>
            }
            trigger={['click']}
            destroyPopupOnHide
            placement="bottomCenter"
            onVisibleChange={(val) => {
                setIsVisible(val);
                setIsDropdownOpen(val);
            }}
            visible={isVisible}
            getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
        >
            <div
                onClick={() => track('MILESTONE_PAD', { category })}
                className="flex flex-col w-full gap-4"
            >
                <div className="flex items-center justify-between bg-white w-full px-8 py-4 cursor-pointer rounded-4">
                    <p className="text-13 font-700">{mileStoneCategoryName[category]}</p>
                    <span>
                        <svg
                            viewBox="0 0 11 7"
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-11 h-7 fill-darwin-neutral_new-1000"
                            style={isVisible ? { rotate: '180deg' } : undefined}
                        >
                            <path d="M4.96094 6.53906L0.460938 2.03906C0.15625 1.75781 0.15625 1.26562 0.460938 0.984375C0.742188 0.679688 1.23438 0.679688 1.51562 0.984375L5.5 4.94531L9.46094 0.984375C9.74219 0.679688 10.2344 0.679688 10.5156 0.984375C10.8203 1.26562 10.8203 1.75781 10.5156 2.03906L6.01562 6.53906C5.73438 6.84375 5.24219 6.84375 4.96094 6.53906Z" />
                        </svg>
                    </span>
                </div>
            </div>
        </Dropdown>
    );
};

const CardComponent: React.FC<{
    caticon: {
        iconFilled: ReactNode;
        iconOutline: ReactNode;
        textClassName: string;
    };
    currCatAchieved: IMilestoneData[];
    currcatmilestones: IMilestoneData[];
    selectedMilestones: string[];
    onSave: (m: IMilestoneData) => void;
    markAllAchieved: (milestones: IMilestoneData[]) => void;
    onUpdateAll: () => void;
    cat: IMilestoneCategory;
}> = ({
    caticon,
    currCatAchieved,
    currcatmilestones,
    selectedMilestones,
    onSave,
    markAllAchieved,
    onUpdateAll,
    cat,
}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    return (
        <div
            className={`flex max-w-256 flex-grow flex-wrap rounded-8 ${
                isDropdownOpen ? 'bg-darwin-accent-bright-blue-100' : 'bg-darwin-neutral_new-50'
            } px-10 py-8`}
        >
            <div className="flex flex-col w-full gap-4">
                <div className="flex gap-8 items-center w-full">
                    {caticon && (
                        <span>
                            {currCatAchieved.length === 0 ||
                            currCatAchieved.length === currcatmilestones.length
                                ? caticon.iconFilled
                                : caticon.iconOutline}
                        </span>
                    )}
                    <DropdownComponent
                        category={cat}
                        currcatmilestones={currcatmilestones}
                        markAllAchieved={markAllAchieved}
                        onSave={onSave}
                        onUpdateAll={onUpdateAll}
                        selectedMilestones={selectedMilestones}
                        setIsDropdownOpen={(val: boolean) => setIsDropdownOpen(val)}
                    />
                </div>

                <p className={`text-13 ${caticon?.textClassName ?? ''}`}>
                    Achieved:{' '}
                    <span className="font-700">
                        {currCatAchieved.length}/{currcatmilestones.length}
                    </span>
                </p>
            </div>
        </div>
    );
};

const MilestoneCardV2: React.FC<{
    icon: ReactNode;
    heading: string;
    milestones: IMilestoneHistory[];
    onElementUpdate: (option: IMilestoneHistory) => void;
    milestoneDataCurrAge: MilestoneData;
    currentAgeGroup: string;
    onUpdateAll: () => void;
    milestoneData: UIMilestone;
    currAgeGroup: number;
}> = ({
    milestones,
    heading,
    icon,
    milestoneDataCurrAge,
    onElementUpdate,
    currentAgeGroup,
    onUpdateAll,
    milestoneData,
    currAgeGroup,
}) => {
    const data = milestoneDataCurrAge?.data;
    const mcategories = data ? Object.keys(data) : [];
    const categories = milestoneCategories.filter((c) => mcategories.includes(c));

    const currAgeGroupIds = useMemo(() => {
        if (data) {
            return Object.values(data).reduce((prev, curr) => {
                prev = [...prev, ...Object.keys(curr)];
                return prev;
            }, [] as string[]);
        }
    }, [data]);

    const [selectedMilestones, setSelectedMilestones] = useState<string[]>([]);

    useEffect(() => {
        if (currAgeGroupIds) {
            const milestoneIds = milestones
                .filter((m) => currAgeGroupIds.includes(m.id))
                .filter(
                    (m) =>
                        m.status === 'achieved' ||
                        m.status === 'achieved_delay' ||
                        m.status === 'achieved_early' ||
                        m.status === 'achieved_unknown',
                )
                .map((m) => m.id);

            setSelectedMilestones(milestoneIds);
        }
    }, [milestones, currAgeGroupIds]);

    const onSave = (m: IMilestoneData) => {
        track('MILESTONE_PAD_SAVE', { milestoneId: m.id, category: m.categoryId });
        setSelectedMilestones((prev) => [...prev, m.id]);
        onElementUpdate({
            id: m.id,
            status: 'achieved',
            category: m.category,
            categoryId: m.categoryId,
            name: m.name,
        });
    };

    const markAllAchieved = (milestones: IMilestoneData[]) =>
        milestones.forEach((m) => {
            onSave(m);
        });

    const ageGroups = Object.keys(milestoneData ?? {});

    const milestonesTillCurrAge = ageGroups.length
        ? ageGroups.slice(0, currAgeGroup === 0 ? 1 : currAgeGroup + 1).reduce((prev, curr) => {
              const data = milestoneData[curr].data;

              const milestones = Object.values(data ?? []);

              return [
                  ...prev,
                  ...milestones.reduce((prev1, curr1) => {
                      const m = Object.values(curr1);
                      return [...prev1, ...Object.values(m)];
                  }, [] as IMilestoneData[]),
              ];
          }, [] as IMilestoneData[])
        : [];

    const milestoneSummary: {
        result?: Record<
            IMilestoneCategory,
            { achieved?: boolean; under_observation?: boolean; delayed?: boolean }
        >;
        statuses?: IMilestoneHistory[];
    } = milestonesTillCurrAge.length
        ? getMilestoneSummary(milestonesTillCurrAge, milestones)
        : { result: undefined };

    const allAchievedMilestones = milestones.filter(
        (milestone) =>
            milestonesTillCurrAge.map((m) => m.id).includes(milestone.id) &&
            (milestone.status === 'achieved' ||
                milestone.status === 'achieved_delay' ||
                milestone.status === 'achieved_early' ||
                milestone.status === 'achieved_unknown'),
    );

    const milestonesLeft = milestonesTillCurrAge.length - allAchievedMilestones.length;

    return (
        <PadV2PxElementCard
            icon={icon}
            headingText={heading}
            iconContainerBgClassName="bg-accent-dark-green"
            bodyCssClassName="space-y-8 min-h-172 rounded-8"
            renderHeaderRight={() => (
                <div
                    onClick={onUpdateAll}
                    className="flex px-6 py-4 cursor-pointer justify-center items-center bg-darwin-accent-bright-blue-100 border border-darwin-accent-bright-blue-800 gap-8 rounded-4"
                >
                    <p className="text-12">
                        {milestonesLeft > 0 ? milestonesLeft : 0} milestones pending
                    </p>
                    <div className="flex items-center gap-4">
                        <p className="text-12 text-darwin-accent-bright-blue-800 font-700">
                            Update all
                        </p>
                        <span>
                            {rightArrowIcon2('w-12 h-12 fill-darwin-accent-bright-blue-800')}
                        </span>
                    </div>
                </div>
            )}
            renderHeaderLeft={() => (
                <div className="flex items-center gap-8">
                    <div
                        style={{
                            height: 'fit-content',
                            width: 'fit-content',
                        }}
                        className="px-6 py-2 text-11 font-700 text-center body-3 bg-darwin-green-primary rounded-4 text-white"
                    >
                        NEW
                    </div>
                    <p className="text-12 relative top-1">Current age group: {currentAgeGroup}</p>
                </div>
            )}
        >
            {milestoneData && !isEmpty(milestoneData) && milestoneDataCurrAge ? (
                <div className="flex flex-col">
                    <MilestoneStatusSummary
                        className="my-8 mx-4"
                        milestoneSummary={milestoneSummary}
                    />

                    <div className="flex gap-16 pt-8 items-center w-full">
                        {categories.map((cat) => {
                            const currcatmilestones = Object.values(data[cat]);
                            const currCatAchieved = currcatmilestones.filter((m) =>
                                selectedMilestones.includes(m.id),
                            );

                            const currCatIds = currcatmilestones.map((c) => c.id);
                            const currCatMarkedMilestones = milestones.filter((m) =>
                                currCatIds.includes(m.id),
                            );

                            const underObsMilestones = currCatMarkedMilestones.find(
                                (m) => m.status === 'under_observation',
                            );

                            const delayedMilestones = currCatMarkedMilestones.find(
                                (m) => m.status === 'delayed',
                            );

                            const caticon = icons(
                                delayedMilestones
                                    ? 'fill-red-primary'
                                    : underObsMilestones
                                    ? 'fill-darwin-accent-bright-yellow-800'
                                    : currCatAchieved.length === 0
                                    ? 'fill-darwin-neutral-600'
                                    : 'fill-darwin-green-primary',
                            )[cat as IMilestoneCategory];

                            return (
                                <CardComponent
                                    cat={cat as IMilestoneCategory}
                                    caticon={caticon}
                                    currCatAchieved={currCatAchieved}
                                    currcatmilestones={currcatmilestones}
                                    markAllAchieved={markAllAchieved}
                                    onSave={onSave}
                                    onUpdateAll={onUpdateAll}
                                    selectedMilestones={selectedMilestones}
                                    key={cat}
                                />
                            );
                        })}
                    </div>
                </div>
            ) : null}
        </PadV2PxElementCard>
    );
};

export default MilestoneCardV2;
